import React from "react";

import PopoverOverlay from "components/UI/_TODO/PopoverOverlay/PopoverOverlay";

import { Switch } from "shared/ui/inputs/Switch/Switch";

import { ReactComponent as SettingsIcon } from "images/icons/settings.svg";

import styles from "./SettingsFilterPopup.module.scss";

// TODO: использовать в Проекте и в Аналитике
const SettingsFilterPopup: React.FC<{
  filters: { label: string; value: boolean; onChange: (value: boolean) => void }[];
}> = ({ filters }) => {
  return (
    <PopoverOverlay
      isMinimal
      modifiers={{
        offset: { enabled: true, options: { offset: [0, 8] } },
      }}
      content={
        <div className={styles.content}>
          <span className={styles.heading}>Настройки отображения</span>
          {filters.map((filter) => (
            <Switch
              key={filter.label}
              label={filter.label}
              checked={filter.value}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => filter.onChange(event.target.checked)}
              className={styles.switch}
            />
          ))}
        </div>
      }
      openType="click"
      placement="bottom-end"
    >
      <div className={styles.relative}>
        <SettingsIcon className={styles.icon} />
        {filters.some((f) => f.value) && <div className={styles.indicator} />}
      </div>
    </PopoverOverlay>
  );
};

export default React.memo(SettingsFilterPopup);
